<template>
  <div class="meet-wrap">
    <div class="page-header">
      <h1 class="title-cn">请选择会议</h1>
      <p class="title-en">Please Select a Conference</p>
    </div>
    <van-checkbox-group v-model="meetChecked" shape="square">
      <template v-for="(group, gIndex) in groupedMeetList" :key="gIndex">
        <!-- 日期标题行 -->
        <div class="date-header-row">
          <span class="date-cn">{{ group.date }}</span>
          <span class="date-en">{{ group.dateEn }}</span>
        </div>
        <!-- 表格 -->
        <table style="margin-top:10px;">
          <!-- 表头 -->
          <tr class="header-row">
            <th class="col-time">时间 <span>Time</span></th>
            <th class="col-name">会议名称 <span>Conference Title</span></th>
            <th style="width:20%" v-if="gIndex===2||gIndex===3" class="col-name">地点 <span>Place</span></th>
          </tr>
          <!-- 会议列表 -->
          <tr v-for="(item, index) in group.meetings" :key="index">
            <td class="col-time">{{ item.time }}</td>
            <td class="col-name">
              <div class="meetItem">
                <van-checkbox :name="item[idType]">
                  <div class="meet-name-cn">{{ item.name }}</div>
                  <div class="meet-name-en">{{ item.nameEn }}</div>
                </van-checkbox>
                <van-field
                  v-if="meetChecked.indexOf(item[idType]) > -1 && item.isClosed"
                  v-model="item.yqCode"
                  label=""
                  placeholder="请输入邀请码"
                />
              </div>
            </td>
            <td v-if="item.place" class="place-col">
              <div class="place-cn">{{ item.place }}</div>
              <div class="place-en">{{ item.eplace }}</div>
            </td>
          </tr>
        </table>
      </template>
      <div class="choose-meet-btn-wrap">
        <van-button plain type="primary" @click="cancelHandler" class="btn-cancel">
          取 消<br /><span class="btn-en">Cancel</span>
        </van-button>
        <van-button type="primary" @click="confirmHandler" class="btn-confirm">
          确 定<br /><span class="btn-en">Confirm</span>
        </van-button>
      </div>
    </van-checkbox-group>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue'
import { showToast } from 'vant'

const emit = defineEmits(['cancel', 'confirm'])
const props = defineProps(['idType', 'hasChecked'])
// ExtField1 下拉
const meetList = [
  {
    isClosed: true,
    name: '中国氢能联盟理事会会议(受邀出席)',
    nameEn: 'CHA Council Meeting (By Invitation Only)',
    id: 1054,
    mid: '993H11D',
    yqCode: '',
    date: '03月25日',
    dateEn: 'March 25',
    time: '09:00-10:00',
    place: '',
    eplace:''
  },
  {
    isClosed: false,
    name: 'CIHC2026国际氢能大会暨“十五五”氢能产业发展论坛',
    nameEn: 'CIHC 2026 & the“15th Five-Year Plan”Hydrogen Development Forum',
    id: 1055,
    mid: '99169DH',
    yqCode: '',
    date: '03月25日',
    dateEn: 'March 25',
    time: '10:00-12:30',
    place: '',
    eplace:''
  },
  {
    isClosed: false,
    name: '绿氢交易国际合作论坛',
    nameEn: 'International Green Hydrogen Trading & Cooperation Forum',
    id: 1068,
    mid: '9N61HM6',
    yqCode: '',
    date: '03月25日',
    dateEn: 'March 25',
    time: '14:00-17:00',
    place:'',
    eplace:''
  },  
  {
    isClosed: false,
    name: '氢能产融创新合作论坛',
    nameEn: 'Hydrogen Industry-Finance Innovation & Cooperation Forum',
    id: 1071,
    mid: '9NHN933',
    yqCode: '',
    date: '03月26日',
    dateEn: 'March 26',
    time: '09:30-17:00',
    place:'',
    eplace:''
  },
  {
    isClosed: false,
    name: '绿氢耦合化工创新论坛',
    nameEn: 'Green Hydrogen-Chemical IndustryIntegration Innovation Forum',
    id: 1070,
    mid: '9NHD16H',
    yqCode: '',
    date: '03月26日',
    dateEn: 'March 26',
    time: '09:30-12:00',
    place:'',
    eplace:''
  },
  
  {
    isClosed: false,
    name: '国际氢能发展论坛',
    nameEn: 'International Hydrogen Development Symposium',
    id: 1072,
    mid: '9N99-MN',
    yqCode: '',
    date: '5月',
    dateEn: 'May',
    time: '5月',
    place:'中国香港',
    eplace:'Hong Kong,China'
  },
  {
    isClosed: false,
    name: '中国国际投资贸易洽谈会-领航中国氢能专题活动',
    nameEn: 'CIFIT - Leading China Hydrogen Energy Special Event',
    id: 1073,
    mid: '9NNQ696',
    yqCode: '',
    date: '9月8日-11日',
    dateEn: 'Sep 8-11',
    time: '9月8日-11日',
    place:'厦门',
    eplace:'Xiamen'
  }
]
const inviteCode = ref('CHA2026')

// 解析时间字符串为分钟数（如 '09:30' -> 570）
const parseTime = (timeStr) => {
  const match = timeStr.match(/(\d{1,2}):(\d{2})/)
  if (!match) return null
  return parseInt(match[1]) * 60 + parseInt(match[2])
}

// 检测两个会议是否时间冲突
const isTimeConflict = (meeting1, meeting2) => {
  // 日期不同，不冲突
  if (meeting1.date !== meeting2.date) return false
  
  // 解析时间范围
  const time1Parts = meeting1.time.split('-')
  const time2Parts = meeting2.time.split('-')
  
  if (time1Parts.length !== 2 || time2Parts.length !== 2) return false
  
  const start1 = parseTime(time1Parts[0])
  const end1 = parseTime(time1Parts[1])
  const start2 = parseTime(time2Parts[0])
  const end2 = parseTime(time2Parts[1])
  
  if (start1 === null || end1 === null || start2 === null || end2 === null) return false
  
  // 判断时间是否重叠
  return !(end1 <= start2 || end2 <= start1)
}

// 检测选中会议的冲突
const checkConflicts = (selectedIds) => {
  const selectedMeetings = meetList.filter(m => selectedIds.includes(m[props.idType]))
  const conflicts = []
  
  for (let i = 0; i < selectedMeetings.length; i++) {
    for (let j = i + 1; j < selectedMeetings.length; j++) {
      if (isTimeConflict(selectedMeetings[i], selectedMeetings[j])) {
        conflicts.push([selectedMeetings[i], selectedMeetings[j]])
      }
    }
  }
  return conflicts
}

// 按日期分组数据
const groupedMeetList = ref([])
meetList.forEach((item) => {
  let group = groupedMeetList.value.find((g) => g.date === item.date)
  if (group) {
    group.meetings.push(item)
  } else {
    groupedMeetList.value.push({
      date: item.date,
      dateEn: item.dateEn,
      meetings: [item]
    })
  }
})

const meetChecked = ref([...props.hasChecked])

// 监听选择变化，检测冲突
watch(meetChecked, (newVal, oldVal) => {
  // 找出新增选中的会议
  const newlySelected = newVal.filter(id => !oldVal.includes(id))
  if (newlySelected.length === 0) return
  
  const newMeeting = meetList.find(m => m[props.idType] === newlySelected[0])
  if (!newMeeting) return
  
  // 检查新选中的会议是否与已选会议冲突
  const existingMeetings = meetList.filter(m => 
    oldVal.includes(m[props.idType])
  )
  
  for (const existing of existingMeetings) {
    if (isTimeConflict(newMeeting, existing)) {
      // 有冲突，移除新选中的会议
     // meetChecked.value = oldVal.slice()
      showToast({
        message: `时间冲突：\n「${newMeeting.name}」\n与\n「${existing.name}」`,
        position: 'middle',
        duration: 3000
      })
      return
    }
  }
}, { deep: true })

const chooseMeetArr = ref([])
const confirmHandler = async () => {
  chooseMeetArr.value = []
  // form.value.ExtField1
  for (let i = 0; i < meetChecked.value.length; i++) {
    const item = meetChecked.value[i]
    const obj = meetList.find((item2) => {
      return item2[props.idType] === item
    })
    if (obj) {
      // 匹配到会议
      if (obj.isClosed) {
        // 闭门会议 验证邀请码
        if (obj.yqCode !== inviteCode.value) {
          return alert(obj.name + '邀请码错误')
        }
      }
      chooseMeetArr.value.push(obj)
    }
  }
  //   const chooseArr = chooseMeetArr.value.map((item) => {
  //     return item[props.idType]
  //   })
  emit('confirm', chooseMeetArr.value)
}
const cancelHandler = () => {
  emit('cancel')
}
</script>

<style lang="less">
.meet-wrap {
  padding: 5vw;
  background-image: url('~@/assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  box-sizing: border-box;

  .page-header {
    text-align: center;
    margin-bottom: 5vw;
    .title-cn {
      font-size: 28px;
      font-weight: bold;
      color: #fff;
      margin: 0 0 8px 0;
    }
    .title-en {
      font-size: 16px;
      color: #fff;
      margin: 0;
    }
  }

  .van-checkbox-group {
    background-color: #fff;
    border-radius: 12px;
    padding: 4vw;
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }

  .date-header-row {
    background-color: #2686f6;
    border-radius: 10px;
    padding: 10px 16px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    .date-cn {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
    .date-en {
      font-size: 14px;
      color: #fff;
    }
  }

  table {
    border-collapse: collapse;
    width: 100%;
    background: #fff;
    margin-bottom: 4vw;
    th, td {
      border: 1px solid #e0e0e0;
      padding: 3vw 2vw;
      vertical-align: middle;
    }
    .header-row {
      th {
        background-color: #c9e3fd;
        font-weight: bold;
        text-align: center;
        font-size: 14px;
        span {
          display: block;
          font-size: 12px;
          font-weight: normal;
          margin-top: 2px;
        }
      }
    }
    .col-time {
      width: 25vw;
      text-align: center;
      font-size: 13px;
      color: #333;
    }
    .place-col {
      width: 15%;
      text-align: center;
      vertical-align: middle;
      .place-cn {
        font-size: 13px;
        color: #333;
      }
      .place-en {
        font-size: 10px;
        color: #666;
      }
    }
    .col-name {
      .meetItem {
        padding: 1vw 0;
        .meet-name-cn {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }
        .meet-name-en {
          font-size: 12px;
          color: #666;
          margin-top: 4px;
        }
        .van-cell {
          padding: 12px 15px 0;
        }
        .van-field__label {
          width: auto;
        }
        .van-field__body {
          margin: 0;
        }
      }
    }
  }

  .choose-meet-btn-wrap {
    display: flex;
    padding-top: 4vw;
    gap: 4vw;
    width: 100%;
    justify-content: center;

    .van-button {
      width: 35vw;
      height: auto;
      padding: 10px 0;
      border-radius: 10px;
      line-height: 1.4;
    }

    .btn-cancel {
      background-color: #fff !important;
      color: #003df2 !important;
      border: 1px solid #003df2 !important;
      .btn-en {
        font-size: 12px;
      }
    }

    .btn-confirm {
      background-color: #003df2 !important;
      color: #fff !important;
      border: none !important;
      .btn-en {
        font-size: 12px;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .meet-wrap {
    padding: 20px;
    min-height: unset !important;
    max-height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;

    .page-header {
      margin-bottom: 20px;
    }

    .van-checkbox-group {
      padding: 20px;
    }

    table {
      margin-bottom: 20px;
      th, td {
        padding: 12px 10px;
      }
      .col-time {
        width: 120px;
      }
      .col-name .meetItem {
        padding: 6px 0;
      }
    }

    .choose-meet-btn-wrap {
      padding-top: 20px;
      gap: 20px;

      .van-button {
        width: 160px;
      }
    }
  }
}
</style>
